// Human-readable labels for each `RefundReason` enum value, used as the subtext on the Refund card.
import { GraphQL } from "@rpi/openapi-api";

const REFUND_REASON_LABELS = new Map<GraphQL.RefundReason, string>([
  // Binding
  [GraphQL.RefundReason.BadSaddleStitching, "Bad Saddle Stitching"],
  [GraphQL.RefundReason.BrokenSpine, "Broken Spine"],
  [GraphQL.RefundReason.EndsheetsAlignment, "Endsheets Alignment"],
  [GraphQL.RefundReason.EndsheetsBubbleWrinkle, "Endsheets Bubble or Wrinkle"],
  [GraphQL.RefundReason.EndsheetsWrong, "Wrong Endsheets"],
  [GraphQL.RefundReason.ExcessiveGlueResidue, "Excessive Glue Residue"],
  [GraphQL.RefundReason.PagesFallingOut, "Pages Falling Out"],
  [GraphQL.RefundReason.PagesNotGluedCorrectlyLayflat, "Pages Not Glued Correctly (Layflat)"],
  [GraphQL.RefundReason.PurGlueSpikes, "PUR Glue Spikes"],
  // Print
  [GraphQL.RefundReason.ColorOutputVariance, "Color Output Variance"],
  [GraphQL.RefundReason.Ghosting, "Ghosting"],
  [GraphQL.RefundReason.InkCrackingInGutterLayflat, "Ink Cracking in Gutter (Layflat)"],
  [GraphQL.RefundReason.MisregistrationColorToColor, "Misregistration Color to Color"],
  [GraphQL.RefundReason.MisregistrationFrontToBack, "Misregistration Front to Back"],
  [GraphQL.RefundReason.SpotsVoidsBandingSmears, "Spots, Voids, Banding, or Smears"],
  [GraphQL.RefundReason.WavyPages, "Wavy Pages"],
  [GraphQL.RefundReason.WrinkledCreasedPages, "Wrinkled or Creased Pages"],
  // Wrong content
  [GraphQL.RefundReason.CompleteWrongOrder, "Complete Wrong Order"],
  [GraphQL.RefundReason.CorrectCoverWrongText, "Correct Cover, Wrong Text"],
  [GraphQL.RefundReason.DuplicatePages, "Duplicate Pages"],
  [GraphQL.RefundReason.MissingPages, "Missing Pages"],
  [GraphQL.RefundReason.PartialWrongOrder, "Partial Wrong Order"],
  [GraphQL.RefundReason.ReceivedAdditionalItems, "Received Additional Items"],
  [GraphQL.RefundReason.SlipsheetBoundInBook, "Slipsheet Bound in Book"],
  [GraphQL.RefundReason.WrongCoverCorrectText, "Wrong Cover, Correct Text"],
  [GraphQL.RefundReason.WrongOrientation, "Wrong Orientation"],
  [GraphQL.RefundReason.WrongPageOrder, "Wrong Page Order"],
  // Cover and finishing
  [GraphQL.RefundReason.CrookedCover, "Crooked Cover"],
  [GraphQL.RefundReason.IncorrectDamagedWireO, "Incorrect or Damaged Wire-O"],
  [GraphQL.RefundReason.IncorrectFoil, "Incorrect Foil"],
  [GraphQL.RefundReason.IncorrectScoreLine, "Incorrect Score Line"],
  [GraphQL.RefundReason.IncorrectSubstrate, "Incorrect Substrate"],
  [GraphQL.RefundReason.LaminationBubbles, "Lamination Bubbles"],
  [GraphQL.RefundReason.LaminationDelamination, "Lamination Delamination"],
  [GraphQL.RefundReason.LaminationWrong, "Wrong Lamination"],
  [GraphQL.RefundReason.TrimmingImageOffCenter, "Trimming Image Off Center"],
  [GraphQL.RefundReason.TrimmingIncorrectDie, "Trimming Incorrect Die"],
  [GraphQL.RefundReason.TrimmingRoughUnclean, "Trimming Rough or Unclean"],
  [GraphQL.RefundReason.TrimmingWrongDimensions, "Trimming Wrong Dimensions"],
  [GraphQL.RefundReason.UvInconsistent, "UV Inconsistent"],
  [GraphQL.RefundReason.UvMissing, "UV Missing"],
  [GraphQL.RefundReason.WrongLinenType, "Wrong Linen Type"],
  [GraphQL.RefundReason.WrongSpineSize, "Wrong Spine Size"],
  // Quantity
  [GraphQL.RefundReason.IncorrectQuantity, "Incorrect Quantity"],
  // Shipping
  [GraphQL.RefundReason.DamageImproperPackaging, "Damage from Improper Packaging"],
  [GraphQL.RefundReason.DamagedInTransit, "Damaged in Transit"],
  [GraphQL.RefundReason.LostInTransit, "Lost in Transit"],
  [GraphQL.RefundReason.PackageNotScanned, "Package Not Scanned"],
  [GraphQL.RefundReason.PhysicalDamage, "Physical Damage"],
  [GraphQL.RefundReason.ReturnedToSender, "Returned to Sender"],
  // Customer / Other
  [GraphQL.RefundReason.NoCredit, "No Credit"],
  [GraphQL.RefundReason.Other, "Other"],
]);

export function getRefundReasonLabel(reason: GraphQL.RefundReason | null | undefined): string | null {
  if (!reason) return null;
  return REFUND_REASON_LABELS.get(reason) ?? null;
}
